import { z } from 'zod';

/** Browser `PushSubscription.toJSON()` and the `/api/push/subscribe` request bodies. */

function allowedPushEndpoint(url: string): boolean {
  try {
    const u = new URL(url);
    if (u.protocol === 'https:') return true;
    return u.protocol === 'http:' && (u.hostname === 'localhost' || u.hostname === '127.0.0.1');
  } catch {
    return false;
  }
}

export const pushEndpointSchema = z
  .string()
  .min(1)
  .max(2048)
  .refine(allowedPushEndpoint, 'Push endpoint must be an https URL');

export const pushSubscriptionJsonSchema = z.object({
  endpoint: pushEndpointSchema,
  expirationTime: z.number().nullable().default(null),
  keys: z.object({
    p256dh: z.string().min(1),
    auth: z.string().min(1),
  }),
});
export type PushSubscriptionJson = z.infer<typeof pushSubscriptionJsonSchema>;
export type PushSubscriptionJsonInput = z.input<typeof pushSubscriptionJsonSchema>;

export const pushSubscribeRequestSchema = z.object({
  subscription: pushSubscriptionJsonSchema,
  userAgent: z.string().max(512).default(''),
});
export type PushSubscribeRequest = z.infer<typeof pushSubscribeRequestSchema>;

export const pushUnsubscribeRequestSchema = z.object({ endpoint: pushEndpointSchema });
export type PushUnsubscribeRequest = z.infer<typeof pushUnsubscribeRequestSchema>;

/** Payload delivered to the service worker (`Detyrë e re` / task title / click → `/tasks/:id`). */
export const pushNotificationPayloadSchema = z.object({
  title: z.string().min(1).max(120),
  body: z.string().max(500).default(''),
  url: z.string().min(1).max(512).default('/'),
  tag: z.string().max(120).optional(),
  taskId: z.string().uuid().optional(),
});
export type PushNotificationPayload = z.infer<typeof pushNotificationPayloadSchema>;
export type PushNotificationPayloadInput = z.input<typeof pushNotificationPayloadSchema>;
